import { useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Textarea } from "../ui/textarea";
import { adminApi, errText } from "./api";
import { Field, SaveBtn, Panel, inputCls } from "./Fields";

export const ReviewsEditor = ({ initial, onSaved }) => {
  const [list, setList] = useState(initial);
  const [busy, setBusy] = useState(false);
  const up = (i, k, v) => setList(list.map((r, j) => (j === i ? { ...r, [k]: v } : r)));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminApi.put("/admin/reviews", list);
      toast.success("Yorumlar kaydedildi");
      onSaved();
    } catch (ex) {
      toast.error(errText(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="space-y-5" data-testid="admin-reviews-form">
      {list.map((r, i) => (
        <Panel key={i} className="space-y-4">
          <div className="flex items-start gap-4">
            <div className="grid flex-1 md:grid-cols-2 gap-4">
              <Field id={`rn-${i}`} label="İsim" value={r.name} required onChange={(e) => up(i, "name", e.target.value)} data-testid={`review-name-${i}`} />
              <Field id={`rc-${i}`} label="Şehir" value={r.city} onChange={(e) => up(i, "city", e.target.value)} data-testid={`review-city-${i}`} />
            </div>
            <button type="button" onClick={() => setList(list.filter((_, j) => j !== i))} aria-label="Sil" data-testid={`review-delete-${i}`}
              className="mt-6 p-2 rounded-full text-red-300 hover:bg-red-500/15"><Trash2 size={16} /></button>
          </div>
          <Textarea rows={3} className={inputCls} value={r.text} required onChange={(e) => up(i, "text", e.target.value)} data-testid={`review-text-${i}`} />
        </Panel>
      ))}
      <div className="flex flex-wrap gap-3">
        <button type="button" onClick={() => setList([...list, { name: "", city: "", text: "" }])} data-testid="admin-review-add"
          className="inline-flex items-center gap-2 rounded-xl border border-dashed border-white/20 bg-white/[0.02] px-6 h-11 font-semibold hover:bg-white/[0.06] hover:border-[#8a8dff]/60 transition-colors">
          <Plus size={16} /> Yorum Ekle
        </button>
        <SaveBtn busy={busy} data-testid="admin-reviews-save">Yorumları Kaydet</SaveBtn>
      </div>
    </form>
  );
};
